import { render, staticRenderFns } from "./ActionsTabParameters.vue?vue&type=template&id=6bdf65aa&scoped=true&"
import script from "./ActionsTabParameters.vue?vue&type=script&lang=js&"
export * from "./ActionsTabParameters.vue?vue&type=script&lang=js&"
import style0 from "./ActionsTabParameters.vue?vue&type=style&index=0&id=6bdf65aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf65aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VFlex,VLayout,VTextField})
